import { ReactNode, useContext, useEffect, useState } from "react";
import { MessagePoppup } from "../../models/MessagePoppup";
import { StyledMessagePoppup } from "./MessagePoppup.styled";
import { Check, Info, Warning, X } from "@phosphor-icons/react";
import { Typography } from "@mui/material";
import { LanguageContext } from "../../globals/LanguageContext";

type MessagePoppupProps = {
  messagePoppup: MessagePoppup;
};

export const MessagePoppupComponent = ({
  messagePoppup,
}: MessagePoppupProps) => {
  const [statusCode, setStatusCode] = useState<number | undefined>(
    messagePoppup.statusCode
  );
  const [type, setType] = useState<"success" | "error" | "info" | "warning">(
    "info"
  );
  const [message, setMessage] = useState<string>("");
  const [backgroundColor, setBackgroundColor] = useState<string>("");
  const [icon, setIcon] = useState<ReactNode>(<></>);
  const { dictionary } = useContext(LanguageContext);

  useEffect(() => {
    switch (statusCode) {
      case 110:
        setType("info");
        break;
      case 111:
        setType("warning");
        break;
      case 200:
      case 201:
      case 202:
        setType("success");
        break;
      case 400:
      case 404:
      case 401:
      case 500:
        setType("error");
        break;
    }
  }, [messagePoppup]);

  useEffect(() => {
    switch (type) {
      case "success": {
        setBackgroundColor("#32a844");
        setIcon(<Check size={32} weight="bold" />);
        setMessage(dictionary.responseMessages.success);
        break;
      }
      case "error":
        setBackgroundColor("#a83232");
        setIcon(<X size={32} weight="bold" />);
        setMessage(dictionary.responseMessages.error);
        break;
      case "warning":
        setBackgroundColor("#ba8b1c");
        setIcon(<Warning size={32} weight="bold" />);
        setMessage(messagePoppup.text || "Warning: no message provided.");
        break;
      default:
        setBackgroundColor("#399D9B");
        setIcon(<Info size={32} weight="bold" />);
        setMessage(messagePoppup.text || "Info: no message provided.");
        break;
    }
  }, [type]);

  return (
    <StyledMessagePoppup backgroundColor={backgroundColor}>
      {icon}
      <Typography variant="h4">{messagePoppup.text || message}</Typography>
      <Typography variant="h4">{statusCode || ""}</Typography>
    </StyledMessagePoppup>
  );
};
